import {
  Grid,
  Toolbar,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  tableCellClasses,
  Collapse,
  Button,
  CircularProgress,
  Box,
  Alert,
  LinearProgress,
  AlertTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../user-redux/selector";
import { appSelector } from "../../redux/selector";
import {
  getCandidateJobdetailsAction,
  getCandidatesRoleBasedJobReportsAction,
  getJobsCountAction,
} from "../../redux/action";
import { styled, alpha } from "@mui/material/styles";

function CandidateJobRoleReports() {
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);
  const { roleBasedJobReports, jobsCount, candidateJobDetails } =
    useSelector(appSelector);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [jobDetailsLoading, setJobDetailsLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleExpandClick = (index, candidate_id) => {
    setJobDetailsLoading(true);
    setExpandedRowIndex(expandedRowIndex === index ? null : index);
    dispatch(getCandidateJobdetailsAction(candidate_id));
    setJobDetailsLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(getJobsCountAction());
      setLoading(false);
    };
    fetchData();
  }, []);
  const handlesourcelinkClick = (jobLink) => {
    if (jobLink) {
      // Open the jobLink in a new tab
      window.open(jobLink, "_blank");
    } else {
      console.error("Job link is not available");
      alert("Job link is not available");
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper>
          <Toolbar
            sx={{
              pl: { sm: 2 },
              pr: { xs: 1, sm: 1 },
              minHeight: "48px !important",
            }}
          >
            <Typography variant="h6">Candidate Job Role Reports</Typography>
          </Toolbar>
        </Paper>
      </Grid>
      <Grid item xs={10}>
        {loading ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt={2}
            p={5}
          >
            <Alert
              severity="info"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Box p={1}>
                <AlertTitle>Fetching Candidates Reports</AlertTitle>
                We are fetching the Reports. Please wait.......
              </Box>
              <LinearProgress style={{ width: "100%" }} />
            </Alert>
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table aria-label="customized table" sx={{ tableLayout: "fixed" }}>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell sx={{ width: "20%" }}>
                    Candidate Name
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "15%" }}>Role</StyledTableCell>
                  <StyledTableCell sx={{ width: "10%" }}>Count</StyledTableCell>
                  {/* <StyledTableCell sx={{ width: '30%' }}>Source Names</StyledTableCell> */}
                  <StyledTableCell sx={{ width: "25%" }}>
                    Actions
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
                <TableBody>
                  {Array.isArray(jobsCount) && jobsCount.length > 0 ? (
                    jobsCount.map((row, index) => (
                      <React.Fragment key={index}>
                        <StyledTableRow>
                          <StyledTableCell>
                            {row.candidate_name || "N/A"}
                          </StyledTableCell>
                          <StyledTableCell>{row.role || "N/A"}</StyledTableCell>
                          <StyledTableCell>{row.jobcount}</StyledTableCell>
                          <StyledTableCell>
                            <Button
                              onClick={() => handleExpandClick(index, row?.candidate_id)}
                            >
                              {expandedRowIndex === index ? "Collapse" : "Expand"}
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>

                        {jobDetailsLoading ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          <TableRow>
                            <TableCell colSpan={4} sx={{ padding: 0 }}>
                              <Collapse in={expandedRowIndex === index}>
                                <TableContainer component={Paper}>
                                  <Table aria-label="detail table" sx={{ tableLayout: "fixed" }}>
                                    <TableHead>
                                      <StyledTableRow>
                                        <StyledTableCell sx={{ width: "20%", height: "20px" }}>
                                          Job Title
                                        </StyledTableCell>
                                        <StyledTableCell sx={{ width: "20%", height: "20px" }}>
                                          Source Name
                                        </StyledTableCell>
                                        <StyledTableCell sx={{ width: "20%", height: "20px" }}>
                                          Job Link
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                      {candidateJobDetails?.length > 0 ? (
                                        candidateJobDetails.map((job, i) => (
                                          <StyledTableRow key={i}>
                                            <StyledTableCell sx={{ width: "20%", height: "20px" }}>
                                              {job.jobtitle || "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "20%", height: "20px" }}>
                                              {job.source_name ? job.source_name : "N/A"}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "20%", height: "20px" }}>
                                              <Button
                                                onClick={() => window.open(job?.job_link, "_blank")}
                                              >
                                                {job?.job_link?.length > 20
                                                  ? `${job?.job_link?.substring(0, 20)}...`
                                                  : "N/A"}
                                              </Button>
                                            </StyledTableCell>
                                          </StyledTableRow>
                                        ))
                                      ) : (
                                        <StyledTableRow>
                                          <StyledTableCell colSpan={3}>
                                            No job titles available
                                          </StyledTableCell>
                                        </StyledTableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={5}>
                        No data available
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>

            </Table>
          </TableContainer>
        )}
      </Grid>
    </Grid>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(64, 104, 130, 0.9)",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  "&.candidateName": {
    width: "25%",
  },
  "&.role": {
    width: "20%",
  },
  "&.roleBasedJobsCount": {
    width: "20%",
  },
  "&.sourceName": {
    width: "20%",
  },
  "&.jobLink": {
    width: "15%",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default CandidateJobRoleReports;
